import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Typography,Select,MenuItem,FormControl,InputLabel,Checkbox,useTheme,Box } from "@mui/material";
import { BOOKMARKT_CATEGORY_DATA ,BOOKMARK_NAME_MAX_LENGTH,BOOKMARK_CATEGORY_MAX_LENGTH, WATCHLIST_NAME_MAX_LENGTH} from "../../../common/utility/constant";
import { UserSettingsContext } from '../../../setup/routes-manager/RequireAuth';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));


export default function CreateWatchlistDialog(props) {
  const theme = useTheme();
  const [open, setOpen] = React.useState(props.open);
  const [title, setTitle] = React.useState(props.name ? props.name : "");
  const {watchlists,setWatchlists} = React.useContext(UserSettingsContext)
  const handleClose = () => {
    props.cancelHandler();
  };

  const handleSave = () => {
    const trimmedTitle = title.trim();

    if (!props.isRename) {
      setWatchlists?.((prev) => ({
        ...(prev || {}),
        [trimmedTitle]: [],
      }));
    }
    props.saveHandler(trimmedTitle);
  };

  const handleTitleChange = (event) => {
     const newTitle = event.target.value;
    const trimmedNewName = newTitle.trim();

    setTitle(newTitle);

    if (props.isRename) {
        const currentWatchlists = watchlists ?? {};

        const watchlistAlreadyExists = Object.keys(currentWatchlists).some(
            (name) =>
                name !== props.name &&
                name.toLowerCase() === trimmedNewName.toLowerCase()
        );

        if (watchlistAlreadyExists) {
            if (props.onSetError) {
                props.onSetError(
                    `Watchlist "${trimmedNewName}" already exists.`
                );
            }
        } else {
            if (props.onClearError) {
                props.onClearError();
            }
        }
    } else {
        if (props.onClearError) {
            props.onClearError();
        }
    }
  };

  // block saving if renaming to the exact same name
  const isUnchanged = props.isRename && title.trim() === (props.name ?? "").trim();
  const hasError = Boolean(props.error);
  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{props.title || "Create Watchlist"}</DialogTitle>
        <DialogContent sx={{ width: "440px", ml: 0, mr: 2 }}>
          <FormControl size="small" sx={{ width: "350px", minWidth: '80px' }}>
            <TextField
              autoFocus
              required
              variant="outlined"
              value={title}
              sx={{ mt: 4, minWidth: 400 }}
              onChange={handleTitleChange}
              inputProps={{ maxLength: WATCHLIST_NAME_MAX_LENGTH }}
              id="name"
              label="Title"
              error={Boolean(props.error)}
              helperText={props.error || ""}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={Boolean(props.error) || title.trim() === "" || isUnchanged  } sx={{ mr: 2 }} onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
